import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/images/green-arrow.svg'
import _imports_1 from '@/images/error.svg'


const _withScopeId = n => (_pushScopeId("data-v-4300a73e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-full overflow-y-auto scroll-area mr-1.5 mt-6 pl-4 pb-40",
  style: {"padding-right":"5px"}
}
const _hoisted_2 = {
  key: 0,
  class: "flex-1 h-full flex justify-center items-center flex-col text-14px text-permaWhite3"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "flex items-center justify-between mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashed" }, null, -1))
const _hoisted_12 = { class: "py-4 flex items-center justify-between" }
const _hoisted_13 = { class: "flex items-start flex-col flex-1 text-18px" }
const _hoisted_14 = {
  key: 0,
  src: _imports_0,
  class: "w-6 h-6",
  alt: "greenArrow"
}
const _hoisted_15 = {
  key: 1,
  src: _imports_1,
  class: "w-6 h-6",
  alt: "error"
}
const _hoisted_16 = { class: "flex items-end flex-col flex-1 text-18px" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashed" }, null, -1))
const _hoisted_18 = { class: "flex justify-between items-center mt-3 text-12px opacity-70" }

import { useStore } from '@/store'
import TokenItem from '@/components/TokenItem.vue'
import { getSwapOrders, OrdersResult, formatAmount } from '../swap/index'
import { FormatedRecord } from '../swap/interface'
import { computed, ref, watch } from 'vue'
import { Token } from '@/libs/everpay-js'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'
import { isProd } from '@/constants'
import LoadMore from '@/components/LoadMore.vue'
import { handleErrorMsg } from '@/libs/util'
import isEmpty from 'lodash/isEmpty'
interface Props {
  visible: boolean
}

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: null
  },
  setup(__props: any) {

const props = __props as {
  visible: boolean
}


const records = ref<FormatedRecord[]>([])
const store = useStore()
const { t } = useI18n()
const account = computed(() => store.state.account)
const tokens = computed(() => store.getters.tokens)
const orderLastHash = ref('')
const noMore = ref(false)
const viewMoreLoading = ref(false)
const modalVisibleLoading = ref(false)
const networkErr = ref(false)
const page = ref(1)
watch(() => props.visible, (newVal, oldVal) => {
  if (newVal) {
    orderLastHash.value = ''
    page.value = 1
    records.value = []
    modalVisibleLoading.value = true
    swapOrders(false)
  } else {
    orderLastHash.value = ''
    page.value = 1
    records.value = []
  }
})
watch(() => account.value, (newVal, oldVal) => {
  if (newVal) {
    orderLastHash.value = ''
    page.value = 1
    records.value = []
    swapOrders(false)
  } else {
    orderLastHash.value = ''
    page.value = 1
    records.value = []
  }
})
const handlePageChange = () => {
  page.value++
  swapOrders(true)
}
const setSwapRecords = (orders: OrdersResult[]) => {
  if (orders.length) {
    if (orderLastHash.value === orders[orders.length - 1].everHash || orders.length < 10) {
      noMore.value = true
    }
    records.value = [...records.value, ...formatOrders(orders)]
    orderLastHash.value = orders[orders.length - 1].everHash
  } else {
    noMore.value = true
  }
  modalVisibleLoading.value = false
  viewMoreLoading.value = false
}
const swapOrders = async (isLoading:boolean) => {
  try {
    if (account.value) {
      networkErr.value = false
      viewMoreLoading.value = true
      noMore.value = false
      const { orders } = await getSwapOrders({
        account: account.value,
        page: page.value
      })
      if (isLoading) {
        setTimeout(() => {
          setSwapRecords(orders)
        }, 800)
      } else {
        setSwapRecords(orders)
      }
    }
  } catch (e:any) {
    orderLastHash.value = ''
    records.value = []
    networkErr.value = true
    handleErrorMsg(e, t)
  }
}

const formatOrders = (orders: OrdersResult[]): FormatedRecord[] => {
  return orders.map((order) => {
    const payToken = tokens.value.find((token: Token) => {
      return token.tag.toLowerCase() === order.tokenInTag.toLowerCase()
    })
    const receiveToken = tokens.value.find((token: Token) => {
      return token.tag.toLowerCase() === order.tokenOutTag.toLowerCase()
    })
    if (payToken && receiveToken) {
      return {
        id: order.id,
        payTokenSymbol: payToken.symbol,
        receiveTokenSymbol: receiveToken.symbol,
        payTokenAmount: formatAmount(order.tokenInAmount),
        receiveTokenAmount: formatAmount(order.tokenOutAmount),
        status: order.status,
        formatTime: dayjs(order.timestamp).format('YYYY-MM-DD HH:mm:ss'),
        everHash: order.everHash
      }
    } else {
      return {} as FormatedRecord
    }
  }).filter((t) => !isEmpty(t))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!orderLastHash.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_unref(account))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('please_log')), 1))
            : (modalVisibleLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)('loading')) + "... ", 1))
              : (networkErr.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)('request_timeout')), 1))
                : (!records.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", null, _toDisplayString(_unref(t)('no_data_order')), 1),
                      (!_unref(account))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('please_log')), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              key: item.everHash,
              href: `https://scan${_unref(isProd) ? '' : '-dev'}.everpay.io/tx/${item.everHash}`,
              class: "mb-6 border border-white border-opacity-10 py-3 px-4 rounded-xl text-14px block hover:bg-permaGreen14 hover:bg-opacity-50 active:bg-opacity-70 transition-colors",
              target: "_blank"
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('swap')), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(item.status === 'success' ? 'text-permaGreen7' :'text-permaRed')
                }, _toDisplayString(item.status === 'success' ? _unref(t)('transaction_success') : _unref(t)('transaction_failed')), 3)
              ]),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, _toDisplayString(item.payTokenAmount), 1),
                  _createVNode(TokenItem, {
                    symbol: item.payTokenSymbol,
                    "logo-size": "w-3 h-3",
                    class: "text-opacity-70 text-12px"
                  }, null, 8, ["symbol"])
                ]),
                (item.status === 'success')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                  : (_openBlock(), _createElementBlock("img", _hoisted_15)),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", null, _toDisplayString(item.receiveTokenAmount), 1),
                  _createVNode(TokenItem, {
                    symbol: item.receiveTokenSymbol,
                    "logo-size": "w-3 h-3",
                    class: "text-opacity-70 text-12px"
                  }, null, 8, ["symbol"])
                ])
              ]),
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('transaction_time')), 1),
                _createElementVNode("span", null, _toDisplayString(item.formatTime), 1)
              ])
            ], 8, _hoisted_9))
          }), 128)),
          _createVNode(LoadMore, {
            "no-more": noMore.value,
            loading: viewMoreLoading.value,
            onLoadMore: handlePageChange
          }, null, 8, ["no-more", "loading"])
        ]))
  ]))
}
}

})